import { registerBlockType } from "@quillforms/blocks";
import Element from "./masked";

registerBlockType("masked", {
  supports: {
    editable: true,
    required: true,
    attachment: true,
    description: true,
    placeholder: true,
    defaultValue: true,
    logic: true,
    theme: true,
  },
  attributes: {
    mask: {
      type: "string",
    },
    replacement: {
      type: "object",
    },
    validators: {
      type: "object",
    },
    uppercase: {
      type: "boolean",
      default: false,
    },
  },
  logicalOperators: [
    "is",
    "is_not",
    "starts_with",
    "contains",
    "ends_with",
    "not_contains",
  ],

  display: (props) => <Element {...props} />,
});
